/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React from "react";
import { IQueryColumnDetails } from "../Interfaces";
import { color } from "echarts";

export const ListColumns: React.FC<{columnDetails: IQueryColumnDetails[]}> = (props) => {

    let i: number = 0;
    const thStyle = {
        textWrap: 'nowrap',
        backgroundColor: '#293042',
        border: '1px solid #deebed',
        fontWeight: 600,
        color:'white',
        // height: '50px',
        padding: '12px 8px', fontSize: '0.75rem'
    };



    // change column names for display
    function transformString(inputString:string) {
        // Check if the input is a string
        if (typeof inputString !== 'string') {
            return inputString;
        }

        // Remove underscores and capitalize letters following each underscore
        const result = inputString
          .split('_') // Split the string by underscores
          .map((word, index) => {
            // Capitalize the first letter of each word after the first
            return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' '); // Join all the words back together
      
        // Ensure the first letter is capitalized
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    const columns: React.ReactElement[] = [];

    //console.log(`This is the column details`, props.columnDetails);

    // Data (Previous Code)
    // props.columnDetails.forEach((column: IQueryColumnDetails) => {
    //     const columnName = column.displayColumnName || column.fullColumnName;
    //     columns.push(
    //         <th key={i++} scope="col" style={thStyle} className="">
    //             <span className="th-name">
    //                {transformString(columnName)}
    //             </span>          
    //         </th>
    //     );
    // });

    // Data
    if (Array.isArray(props.columnDetails)) {
        props.columnDetails.forEach((column: IQueryColumnDetails) => {
            const columnName = column.displayColumnName || column.fullColumnName;
            const fullColumnName = column.fullColumnName?.toLowerCase();

            if (!columnName || fullColumnName === 'notifications.reference') return;
            if (!columnName || fullColumnName === 'id') return;

            const displayName = fullColumnName === 'assets.url'
                ? 'Image'
                : transformString(columnName);

            columns.push(
                <th key={i++} scope="col" style={thStyle}>
                    <span className="th-name">{displayName}</span>
                </th>
            );
        });
    }

    return(
        <>
        <thead className="sa-list-columns">
            <tr>                             
                {columns}                 
                <th className="sa-record-control sa-export-selected-records" style={thStyle}>
                    Actions
                </th>                                         
            </tr>
        </thead>
        </>
    );
}